import { Controller } from "@hotwired/stimulus"
import { startIcons } from "../import_lucid.js"

export default class extends Controller {
  static targets = [ "modal", "modalBg", "scheduleButton", "scheduleSummary" ]

  connect() {
    this.updateButtonText()
    this.updatePositions()
  }

  openSchedule(event) {
    event.preventDefault()
    this.modalBgTarget.classList.remove('hidden')
    this.modalTarget.classList.remove('hidden')
  }

  closeSchedule(event) {
    event.preventDefault()
    this.modalBgTarget.classList.add('hidden')
    this.modalTarget.classList.add('hidden')
    this.updateButtonText()
  }

  updateButtonText() {
    const input = this.element.querySelector('input[name*="[schedule]"]')
    const summaryTarget = this.hasScheduleSummaryTarget ? this.scheduleSummaryTarget : null

    if (input && input.value && input.value.trim() !== "") {
      if (summaryTarget) {
        summaryTarget.dataset.cronSummaryCronValue = input.value
      }
      if (this.hasScheduleButtonTarget) {
        this.scheduleButtonTarget.classList.add("bg-brand-soft", "text-brand", "border-brand")
        this.scheduleButtonTarget.classList.remove("text-ink-muted", "border-hair-hi")
      }
    } else {
      if (summaryTarget) {
        summaryTarget.dataset.cronSummaryCronValue = ""
      }
      if (this.hasScheduleButtonTarget) {
        this.scheduleButtonTarget.classList.remove("bg-brand-soft", "text-brand", "border-brand")
        this.scheduleButtonTarget.classList.add("text-ink-muted", "border-hair-hi")
      }
    }
  }

  updatePositions() {
    const wrappers = this.element.querySelectorAll(".nested-form-wrapper")
    let currentPosition = 1
    wrappers.forEach((wrapper) => {
      startIcons(wrapper)
      
      const destroyInput = wrapper.querySelector("input[name*='_destroy']")
      const isDeleted = destroyInput && destroyInput.value === "1"

      if (!isDeleted && wrapper.style.display !== 'none') {
        const positionInput = wrapper.querySelector(".step-position")
        if (positionInput) {
          positionInput.value = currentPosition++
        }
      }
    })
  }

  removeStep(event) {
    event.preventDefault()
    const button = event.currentTarget
    const wrapper = button.closest(".nested-form-wrapper")
    const card = wrapper.querySelector(".step-card")
    const badge = wrapper.querySelector(".pending-badge")
    const iconContainer = button.querySelector('svg') || button.querySelector('i')

    if (wrapper.dataset.newRecord === "true") {
      wrapper.remove()
      this.updatePositions()
      return
    }

    const destroyInput = wrapper.querySelector("input[name*='_destroy']")
    if (!destroyInput) return

    const isDeleted = destroyInput.value === "1"

    if (isDeleted) {
      // RESTORE
      destroyInput.value = "0"

      // UI Reset
      card.classList.remove("bg-state-bad-soft", "border-state-bad/25")
      card.classList.add("bg-surface", "border-hair")
      
      // Re-enable inputs
      wrapper.querySelectorAll("input, select").forEach(el => {
          if (el.type !== 'hidden') {
              el.style.pointerEvents = "auto"
              el.style.opacity = "1"
          }
      })

      badge.classList.add("hidden")

      // Change Icon to Trash
      if (iconContainer) {
         const i = document.createElement("i")
         i.setAttribute("data-lucide", "trash-2")
         i.classList.add("w-4", "h-4")
         iconContainer.replaceWith(i)
         startIcons(button)
      }
      
      button.classList.remove("text-brand", "hover:text-brand-hover", "hover:bg-brand-soft")
      button.classList.add("text-ink-faint", "hover:text-state-bad", "hover:bg-state-bad-soft")
      button.setAttribute("aria-label", button.getAttribute("aria-label").replace(/^Restore /, "Remove "))

    } else {
      // DELETE
      destroyInput.value = "1"

      // UI Delete State
      card.classList.remove("bg-surface", "border-hair")
      card.classList.add("bg-state-bad-soft", "border-state-bad/25")
      
      // Disable inputs visually
      wrapper.querySelectorAll("input, select").forEach(el => {
          if (el.type !== 'hidden') {
              el.style.pointerEvents = "none"
              el.style.opacity = "0.4"
          }
      })

      badge.classList.remove("hidden")

      // Change Icon to Undo/Redo
      if (iconContainer) {
         const i = document.createElement("i")
         i.setAttribute("data-lucide", "rotate-cw")
         i.classList.add("w-4", "h-4")
         iconContainer.replaceWith(i)
         startIcons(button)
      }

      button.classList.remove("text-ink-faint", "hover:text-state-bad", "hover:bg-state-bad-soft")
      button.classList.add("text-brand", "hover:text-brand-hover", "hover:bg-brand-soft")
      button.setAttribute("aria-label", button.getAttribute("aria-label").replace(/^Remove /, "Restore "))
    }
    this.updatePositions()
  }
}
